// Ground glide ratio with wind. Mirrors `glide_solver::Glide::ground_gr` so the profile chart and
// the reach map agree.

export interface Wind {
  /** km/h */
  speed: number;
  /** Direction the wind comes from, degrees. */
  from: number;
  /** Trim airspeed, km/h. */
  airspeed: number;
}

export const NO_WIND: Wind = { speed: 0, from: 0, airspeed: 38 };

/**
 * Glide ratio over the ground when tracking `heading` (degrees). The pilot crabs to hold the
 * track. Returns null when the track cannot be flown (ground speed <= 0).
 */
export function groundGlide(gr: number, heading: number, w: Wind): number | null {
  if (w.speed === 0) return gr;
  const to = ((w.from + 180) * Math.PI) / 180;
  const we = w.speed * Math.sin(to);
  const wn = w.speed * Math.cos(to);
  const h = (heading * Math.PI) / 180;
  const ue = Math.sin(h);
  const un = Math.cos(h);
  const along = we * ue + wn * un;
  const cross = we * un - wn * ue;
  const va2 = w.airspeed * w.airspeed;
  if (cross * cross >= va2) return null;
  const vg = along + Math.sqrt(va2 - cross * cross);
  if (vg <= 1e-3 * 3.6) return null;
  return (gr * vg) / w.airspeed;
}

/** Margin required `s` metres after launch: ramps from 0 to `margin` over `ramp` metres. */
export function marginAt(margin: number, ramp: number, s: number): number {
  return ramp <= 0 || s >= ramp ? margin : (margin * s) / ramp;
}
